module.exports = __webpack_public_path__ + "img/bridge-purple.a07437b1.svg";